var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFixedDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-236 -782)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(383 1705.253)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.785,
    height: 11.785,
    rx: 0.5,
    transform: "matrix(0.966, -0.259, 0.259, 0.966, -145.066, -918.753)",
    fill: "#4f5b6d"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.785,
    height: 11.785,
    rx: 0.5,
    transform: "matrix(0.966, 0.259, -0.259, 0.966, -142.016, -921.803)",
    fill: "#4f5b6d"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.785,
    height: 11.785,
    rx: 0.5,
    transform: "translate(-137.85 -922.919) rotate(45)",
    fill: "#4f5b6d"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-141.343 -919.505)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.722,3.457h-.576V2.689a2.689,2.689,0,1,0-5.378,0v.768h-.576A.192.192,0,0,0,64,3.649v4.8a.769.769,0,0,0,.768.768h5.378a.769.769,0,0,0,.768-.768v-4.8A.192.192,0,0,0,70.722,3.457Zm-2.69,4.012a.192.192,0,0,1-.191.213h-.768a.192.192,0,0,1-.191-.213L67,6.38a.76.76,0,0,1-.314-.618.768.768,0,1,1,1.537,0,.76.76,0,0,1-.314.618Zm.961-4.012H65.921V2.689a1.536,1.536,0,1,1,3.073,0Z",
    transform: "translate(-64)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFixedDiscount);
export default __webpack_public_path__ + "static/media/fixed-discount.38a886c73e4f2db643b4ad2f37080fec.svg";
export { ForwardRef as ReactComponent };